export const menu = [
  // {
  //   name: "Classroom Management",
  //   path: "/classroom-management",
  // },
  {
    name: "Qualifications",
    path: "/qualifications",
  },
  {
    name: "Demo Lessons",
    path: "/protected/demo-lessons",
  },
  {
    name: "Gallery",
    path: "/protected/gallery",
  },
  // {
  //   name: "Projects",
  //   path: "/projects",
  // },
  {
    name: "Contact",
    path: "/contact",
  },
]

export const classroomManagement = [
  {
    name: "Positive Classroom Climate",
    path: "/classroom-management/positive-climate",
  },
  {
    name: "Routines & Procedures",
    path: "/classroom-management/routines-procedures",
  },
  {
    name: "Behavior Management & Intervention",
    path: "/classroom-management/behavior-management",
  },
]
